'use client';
// Fallback при неперехваченной ошибке выполнения — предотвращает белый экран
// + отправка в систему трекинга ошибок через общий reportClientError
import { useEffect } from 'react';
import { reportClientError } from '@tb/ui';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError({
      service: 'lk',
      severity: 'error',
      name: error.name || 'RenderError',
      message: error.message || error.toString(),
      stack: error.stack,
      context: { source: 'error_boundary', digest: error.digest },
    });
  }, [error]);

  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center p-6 text-center">
      <div className="mb-6 flex justify-center">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted-foreground">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <h1 className="mb-2 text-xl font-semibold">Что-то пошло не так</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Произошла непредвиденная ошибка. Попробуйте обновить страницу.
      </p>
      <div className="flex justify-center gap-3">
        <button
          onClick={reset}
          className="rounded-lg bg-primary px-5 py-2 text-sm font-semibold text-white hover:bg-primary/90"
        >
          Попробовать снова
        </button>
        <a
          href="/"
          className="rounded-lg border border-input px-5 py-2 text-sm font-semibold hover:bg-accent"
        >
          На главную
        </a>
      </div>
    </main>
  );
}
